angular.module("ainapp")
    .controller("HomeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {




            $scope.init = function () {

                $scope.TokenInfo = AuthenticationService.getTokenInfo();

                $scope.MonthlySalesChartData = {};
                MainService.TopSellingProductChart().then(function (response) {
                    $scope.MonthlySalesChartData = response.data;
                    if ($scope.MonthlySalesChartData != null) {
                        $scope.MonthlySalesChartFun();
                    }
                }, function () {})

                $scope.SalesOrders = [];
                MainService.SalesOrdersInHome().then(function (response) {
                    $scope.SalesOrders = response.data;
                }, function () {})

                $scope.MDCounts = [];
                MainService.MainDashboardCounts().then(function (response) {
                    $scope.MDCounts = response.data;
                }, function () {})

                $scope.Reminders = [];
                MainService.RemindersInHome($scope.TokenInfo.UserId).then(function (response) {
                    $scope.Reminders = response.data;
                })

                $scope.Docs = [];
                MainService.DocsInHome($scope.TokenInfo.UserId).then(function (response) {
                    $scope.Docs = response.data;
                })
                $scope.HomeData = [];
                MainService.GetHomeData().then(function (response) {
                    $scope.HomeData = response.data;
                })

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                    if ($scope.CompanyProfile.IsHR) {
                        $scope.EmpDocs = [];
                        MainService.EmployeeDocsInHome().then(function (response) {
                            $scope.EmpDocs = response.data;
                            if ($scope.EmpDocs.length > 0) {
                                $('#empDocModal').modal('show');
                            }
                        })
                    }
                })


            }
            $scope.init();


            $scope.MonthlySalesChartFun = function () {

                $("#monthlysalesChart").kendoChart({
                    title: {
                        text: "Top Selling Items"
                    },
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "bar"
                    },
                    chartArea: {
                        height: 300
                    },
                    series: $scope.MonthlySalesChartData.series,
                    categoryAxis: {
                        categories: $scope.MonthlySalesChartData.categories
                    },
                    tooltip: {
                        visible: true,
                        template: "#= category #: #= value #"
                    }
                });


            }


            $scope.deleteReminder = function (id) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeleteReminder(id).then(function (response) {
                    if (response.data) {
                        toastr.success("Deleted");

                        $scope.Reminders = [];
                        MainService.RemindersInHome($scope.TokenInfo.UserId).then(function (response) {
                            $scope.Reminders = response.data;
                        })

                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");

                });
            }


            $scope.EditSalesOrder = function (data) {
                $state.go("editSalesOrder", {
                    VoucherId: data.Id
                })
            };

            //            $scope.MonthlySalesChart = function () {
            //                $("#chart22").kendoChart({
            //                    title: {
            //                        position: "bottom",
            //                        text: "Monthly Sales"
            //                    },
            //                    legend: {
            //                        visible: false
            //                    },
            //                    chartArea: {
            //                        background: ""
            //                    },
            //                    seriesDefaults: {
            //                        labels: {
            //                            visible: true,
            //                            background: "transparent",
            //                            template: "#= category #: \n #= value#"
            //                        }
            //                    },
            //                    series: [{
            //                        type: "pie",
            //                        startAngle: 150,
            //                        data: $scope.MonthlySales,
            //                        tooltip: {
            //                            visible: true,
            //                            format: "{0}"
            //                        }
            //                }]
            //                })
            //            }
            //
            //            $scope.ExpenseCurrentFun = function () {
            //                $("#chart").kendoChart({
            //                    title: {
            //                        position: "bottom",
            //                        text: "Expense Current Month"
            //                    },
            //                    legend: {
            //                        visible: false
            //                    },
            //                    chartArea: {
            //                        background: ""
            //                    },
            //                    seriesDefaults: {
            //                        type: "donut",
            //                        startAngle: 150
            //                    },
            //                    series: [{
            //                        name: "2011",
            //                        data: $scope.CurrentExpense
            //                                        }],
            //                    tooltip: {
            //                        visible: true,
            //                        template: "#= category # : #= value #"
            //                    }
            //                });
            //            }
            //
            //            $scope.CostFun = function () {
            //                $("#chart212").kendoChart({
            //                    title: {
            //                        text: "Cost Center -Expense  Summary"
            //                    },
            //                    legend: {
            //                        position: "bottom"
            //                    },
            //                    seriesDefaults: {
            //                        type: "line",
            //                        stack: true
            //                    },
            //                    series: $scope.costCenters,
            //                    valueAxis: {
            //                        line: {
            //                            visible: false
            //                        }
            //                    },
            //                    categoryAxis: {
            //                        categories: $scope.costCenters[0].categories,
            //                        majorGridLines: {
            //                            visible: false
            //                        }
            //                    },
            //                    tooltip: {
            //                        visible: true,
            //                        format: "{0}"
            //                    }
            //                });
            //            }
            //
            //            $scope.ProfitChart = function () {
            //
            //                $("#chart-income").kendoChart({
            //                    legend: {
            //                        visible: false
            //                    },
            //                    series: [{
            //                        type: "bullet",
            //                        data: $scope.HomeData.IncomeArray,
            //                                        }],
            //                    chartArea: {
            //                        margin: {
            //                            left: 0
            //                        }
            //                    },
            //                    categoryAxis: {
            //                        majorGridLines: {
            //                            visible: false
            //                        },
            //                        majorTicks: {
            //                            visible: false
            //                        }
            //                    },
            //                    valueAxis: [{
            //                        majorGridLines: {
            //                            visible: false
            //                        },
            //                        min: 0,
            //                        max: $scope.HomeData.Income + 1000,
            //                        minorTicks: {
            //                            visible: true
            //                        }
            //                                        }],
            //                    tooltip: {
            //                        visible: true,
            //                        template: " Income: #= value.current #"
            //                    }
            //                });
            //
            //                $("#chart-expense").kendoChart({
            //                    legend: {
            //                        visible: false
            //                    },
            //                    series: [{
            //                        type: "bullet",
            //                        data: $scope.HomeData.ExpenseArray,
            //                    }],
            //                    chartArea: {
            //                        margin: {
            //                            left: 0
            //                        }
            //                    },
            //                    categoryAxis: {
            //                        majorGridLines: {
            //                            visible: false
            //                        },
            //                        majorTicks: {
            //                            visible: false
            //                        }
            //                    },
            //                    valueAxis: [{
            //                        majorGridLines: {
            //                            visible: false
            //                        },
            //                        min: 0,
            //                        max: $scope.HomeData.Expense + 1000,
            //                        minorTicks: {
            //                            visible: true
            //                        }
            //                                        }],
            //                    tooltip: {
            //                        visible: true,
            //                        template: "Expense : #= value.current #"
            //                    }
            //                });
            //            }
            //
            //            $scope.Init = function () {
            //
            //                $scope.HomeData = {};
            //                MainService.GetHomeData().then(function (response) {
            //                    if (response) {
            //                        $scope.HomeData = response.data;
            //                        $scope.HomeData.ExpenseArray = [];
            //                        $scope.HomeData.ExpenseArray.push(response.data.Expense);
            //                        $scope.HomeData.IncomeArray = [];
            //                        $scope.HomeData.IncomeArray.push(response.data.Income);
            //                        $scope.ProfitChart();
            //                    }
            //                }, function () {})
            //
            //                $scope.MonthlySales = [];
            //                MainService.GetMonthlySales().then(function (response) {
            //                    if (response) {
            //                        $scope.MonthlySales = response.data;
            //                        $scope.MonthlySalesChart();
            //                    }
            //                }, function () {})
            //
            //                $scope.CurrentExpense = [];
            //                MainService.GetCurrentMonthExpense().then(function (response) {
            //                    if (response) {
            //                        $scope.CurrentExpense = response.data;
            //                        $scope.ExpenseCurrentFun();
            //                    }
            //                }, function () {})
            //
            //                $scope.costCenters = [];
            //                MainService.CostCenterSummary().then(function (response) {
            //                    if (response) {
            //                        $scope.costCenters = response.data;
            //                        $scope.CostFun();
            //                    }
            //                }, function () {})
            //
            //            }
            //            $scope.Init();

                    }])
